import { Component, OnInit } from '@angular/core';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { of } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { ActivityManagementService } from '../../../activity-management.service';
import { ModalConsultComponent } from '../../modal-consult/modal-consult.component';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';

@Component({
  selector: 'app-duplicate-consult',
  templateUrl: './duplicate-consult.component.html',
  styleUrls: ['./duplicate-consult.component.scss']
})
export class DuplicateConsultComponent implements OnInit {
  date: Date;
  duplicateDate: Date = null;
  uid: string;
  consultDetails;
  times = [];
  model = [];
  status = [];
  selected = [];
  isCreate: boolean;

  constructor(
    public matDialog: MatDialog,
    private router: Router,
    private activityManagementService: ActivityManagementService,
    private gobalFunctionService: GobalFunctionService
  ) { }

  ngOnInit(): void {
    // // console.log(window.history.state);
    // // console.log(window.history.state['consult-uid']);
    this.gobalFunctionService.setTitle('Duplicate Consult');

    if (!window.history.state['consult-uid']) {
      this.router.navigate(['activity-management/consult']);
    } else {
      this.uid = window.history.state['consult-uid'];
      this.date = new Date(+window.history.state['consult-date']);
    }
  }

  selectDate(date) {
    if (date) {
      this.getConsultDetail();
    }
  }

  getConsultDetail() {
    if (this.duplicateDate) {
      let now = new Date();
      let d = new Date(new Date(this.duplicateDate).setHours(now.getHours()));

      let dateToServer = d.toISOString().slice(0, 10);

      this.activityManagementService.getDetailConsultByDate({ USER_ID: this.uid, CONSULT_DATE: dateToServer }).subscribe(res => {
        this.consultDetails = res.result;
        // // console.log(this.consultDetails);
        for (let i = 0; i < res.result.length; i++) {
          this.times[i] = new Date(this.consultDetails[i].CONSULT_DATE);
          if (this.consultDetails[i].CONSULT_STATUS === 'joined' || this.consultDetails[i].CONSULT_STATUS === 'busy') {
            this.status[i] = true;
          } else {
            this.status[i] = false;
          }
        }
        this.checkCreate();
      })
    }
  }

  add(e, c, i) {
    e.preventDefault();
    // // console.log(this.consultDetails[i]);

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '450px';
    dialogConfig.autoFocus = false;

    if (c.CONSULT_STATUS === 'empty' || c.CONSULT_STATUS === 'delete') {
      dialogConfig.data = {
        title: 'สร้างช่วงเวลา',
        actionBtnText: 'เพิ่ม',
        value: c,
        uid: this.uid,
        isEdit: false
      }
    }
    // // console.log(c);

    const modal = this.matDialog.open(ModalConsultComponent, dialogConfig);
    modal.afterClosed().subscribe(res => {
      if (res.status) {
        c.CONSULT_DETAIL.push(res.obj);
        this.status[i] = !this.status[i];
        this.selected[i] = res.obj;
        c.CONSULT_STATUS = 'busy';
        this.checkCreate();
        // // console.log(this.selected);
      }
    })
  }

  edit(e, c, i) {
    e.preventDefault();

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '450px';
    dialogConfig.autoFocus = false;
    if (c.CONSULT_STATUS === 'busy' || c.CONSULT_STATUS === 'edit') {
      dialogConfig.data = {
        title: 'แก้ไขช่วงเวลา',
        actionBtnText: 'บันทืก',
        value: c.CONSULT_DETAIL[0],
        uid: this.uid,
        isEdit: true
      }
    }

    const modal = this.matDialog.open(ModalConsultComponent, dialogConfig);
    modal.afterClosed().subscribe(res => {
      if (res.status) {
        this.selected[i] = res.obj;
        c.CONSULT_STATUS = 'edit';
      }
      if (res.isDelete) {
        this.status[i] = false;
        this.selected[i] = res.obj;
        c.CONSULT_STATUS = 'delete';
      }
      this.checkCreate();
    })
  }

  create() {
    let createArray = [];
    let data;

    for (let i = 0; i < this.consultDetails.length; i++) {
      if (this.consultDetails[i].CONSULT_STATUS === 'busy' || this.consultDetails[i].CONSULT_STATUS === 'joined' || this.consultDetails[i].CONSULT_STATUS === 'edit') {
        // console.log(this.selected[i]);

        if (this.selected[i]) {
          data = {
            USER_ID: this.uid,
            CONSULT_ID: '',
            CONSULT_CREATE_TYPE: 'create',
            CONSULT_TYPE: this.consultDetails[i].CONSULT_DETAIL[0].CONSULT_TYPE,
            CONSULT_DATE_START: new Date(new Date(this.consultDetails[i].CONSULT_DETAIL[0].CONSULT_DATE_START).setFullYear(this.date.getFullYear(), this.date.getMonth(), this.date.getDate())),
            CONSULT_DATE_END: new Date(new Date(this.consultDetails[i].CONSULT_DETAIL[0].CONSULT_DATE_END).setFullYear(this.date.getFullYear(), this.date.getMonth(), this.date.getDate())),
            CONSULT_MAX: this.selected[i].CONSULT_MAX,
            CONSULT_SOLUTION: this.selected[i].CONSULT_SOLUTION,
            CONSULT_OBJECT: this.selected[i].CONSULT_OBJECT
          }
        } else {
          data = {
            USER_ID: this.uid,
            CONSULT_ID: '',
            CONSULT_CREATE_TYPE: 'create',
            CONSULT_TYPE: this.consultDetails[i].CONSULT_DETAIL[0].CONSULT_TYPE,
            CONSULT_DATE_START: new Date(new Date(this.consultDetails[i].CONSULT_DETAIL[0].CONSULT_DATE_START).setFullYear(this.date.getFullYear(), this.date.getMonth(), this.date.getDate())),
            CONSULT_DATE_END: new Date(new Date(this.consultDetails[i].CONSULT_DETAIL[0].CONSULT_DATE_END).setFullYear(this.date.getFullYear(), this.date.getMonth(), this.date.getDate())),
            CONSULT_MAX: this.consultDetails[i].CONSULT_DETAIL[0].CONSULT_MAX,
            CONSULT_SOLUTION: this.consultDetails[i].CONSULT_DETAIL[0].CONSULT_SOLUTION,
            CONSULT_OBJECT: this.consultDetails[i].CONSULT_DETAIL[0].CONSULT_OBJECT
          }
        }
        createArray.push(data);
      }
    }

    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '350px';
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      title: 'ยืนยันการบันทึก',
      description: `คุณต้องการบันทึก Consult ใช่หรือไม่?`,
      actionBtnText: 'ยืนยัน',
      cancleBtnText: 'ยกเลิก',
    }

    const modal = this.matDialog.open(ModalComponent, dialogConfig);
    modal.afterClosed().pipe(
      switchMap(res => {
        if (res) {
          return this.activityManagementService.createConsult(createArray).pipe(
            switchMap(() => {
              const dialogConfig2 = new MatDialogConfig();
              dialogConfig2.disableClose = true;
              dialogConfig2.id = 'modalSuccess';
              dialogConfig2.width = '350px';
              dialogConfig2.data = {
                title: 'สำเร็จแล้ว',
                description: `<img src="../../../assets/check.png" width="100px"; class="img-center">บันทึก Consult สำเร็จแล้ว`,
                cancleBtnText: 'ยืนยัน',
                customStyle: 'background-color: #58595B;'
              }
              const modal2 = this.matDialog.open(ModalComponent, dialogConfig2);
              return modal2.afterClosed().pipe(
                map(res => {
                  // console.log(res);
                  this.duplicateDate = null;
                  this.selected = [];
                  this.getConsultDetail();
                  this.router.navigate(['activity-management/consult']);
                })
              )
            })
          )
        } else {
          return of(null);
        }
      })
    ).subscribe()
  }

  getHourse(t) {
    return t.getHours() + ':00';
  }

  checkCreate() {
    let haveTrueStatus = this.status.filter(v => v === true).length;
    if (haveTrueStatus > 0) {
      this.isCreate = true;
    } else {
      this.isCreate = false;
    };
  }
}
